<template>
  <q-card class="dash-number-box bg-white">
    <q-card-main>
      <div class="row gutter-x-md">
        <div class="col-auto">
          <q-icon name="timer" class="circle bg-red-1 text-red-5 q-pa-sm q-mt-xs" style="font-size: 1.75rem;"/>
        </div>
        <div class="col">
          <span class="dash-number-box__value--small">{{ amount }}</span>
          <h2 class="dash-number-box__heading--small">{{ $tc('statistics_open_hours', amount ) }}</h2>
        </div>
      </div>
    </q-card-main>
  </q-card>
</template>

<script>
  export default {
    props: {
      amount: {
        type: Number,
        required: true
      }
    }
  }
</script>
